import Vue from 'vue'
import Vuex, { Commit, Dispatch } from 'vuex'

import snacks, { State as SnackState } from './modules/snack'
import user, { State as UserState } from './modules/user'
import page, { State as PageState } from './modules/page'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    snacks,
    user,
    page
  }
})

export interface ActionContextBasic {
  commit: Commit;
  dispatch: Dispatch;
}
export interface State {
  snacks: SnackState;
  user: UserState;
  page: PageState;
}
